import React from 'react'
import './ItemChat.css'
import {defaultAvatarUrl} from '@utils/Const'
import {Box, Flex, Image, Text} from '@chakra-ui/react'
import appRequest from '@apis/app'
import IcTranslate from '@assets/svgs/ic_translate_gray.svg'

const ItemBotMessage = ({message}: any) => {
  const [responseTranslate, setResponseTranslate] = React.useState('')
  const handleConnectTranslate = (_data: any) => {
    try {
      let newContent = ''
      _data?.forEach((e: any) => {
        newContent += e?.trans
      })
      return newContent
    } catch (e) {
      return ''
    }
  }
  const handleTranslate = async () => {
    const response = await appRequest.translateToVn({
      dt: 't',
      client: 'gtx',
      sl: 'en',
      tl: 'vi',
      dj: 1,
      q: message?.message,
    })
    const newTranslate = handleConnectTranslate(response?.data?.sentences)
    setResponseTranslate(newTranslate)
  }

  return (
    <Flex gap={{base: '10px', md: '16px'}} w={'95%'}>
      <Image
        src={defaultAvatarUrl}
        alt="Avatar"
        w={{base: '32px', md: '40px'}}
        h={{base: '32px', md: '40px'}}
      />
      <Box
        bg={'white'}
        borderRadius={'24px'}
        boxShadow={
          '0 4px 8px 0 rgba(0, 0, 0, 0.05), 0 6px 20px 0 rgba(0, 0, 0, 0.05)'
        }
        padding={{base: '10px', md: '16px'}}>
        <Text whiteSpace="pre-line">{message?.message}</Text>
        {!!responseTranslate && (
          <Text style={{marginTop: 10}}>{responseTranslate}</Text>
        )}
        {!responseTranslate && (
          <Box cursor={'pointer'} onClick={handleTranslate}>
            <Image alt={'trans-ic'} h={'20px'} w={'20px'} src={IcTranslate} />
          </Box>
        )}
      </Box>
    </Flex>
  )
}

export default ItemBotMessage
